/* eslint-disable no-undef */
import { getUser } from "actions/user";
import axios from "axios"

export let country = localStorage.getItem('country') || 'sg';
export const authInstanceAxios = axios.create()

export function initConfig() {

    const user = getUser()
    authInstanceAxios.defaults.baseURL = process.env.REACT_APP_API_URL

    if (user)
        authInstanceAxios.defaults.headers["Authorization"] = user.jwt

    axios.defaults.baseURL = process.env.REACT_APP_API_URL

}